module.exports = __webpack_public_path__ + "img/local-pass-reclaim-weekdays-mobile.jpg";